export enum TimeBandFlagsEnum {
    None = 0x00000000,
    OperatingMachine = 0x00000001,
    OnlyDeposit = 0x00000002,
    EmptyoutPossible = 0x00000004,
    EmptyoutPossibleWithAlarm = 0x00000008,
    DoorOpen = 0x00000010,
    DoorOpenWithAlarm = 0x00000020,
}
